import React from "react";
import "./ArrowIcon.css";

const paths = {
  external: "M5 19 19 5M8 5h11v11",
  left: "M20 12H4m6-6-6 6 6 6",
  right: "M4 12h16m-6-6 6 6-6 6",
  both: "M4 12h16M9 7l-5 5 5 5m6-10 5 5-5 5",
};

const ArrowIcon = ({ direction = "external", className = "" }) => (
  <svg className={`arrow-icon${className ? ` ${className}` : ""}`} viewBox="0 0 24 24" aria-hidden="true" focusable="false">
    <path d={paths[direction]} />
  </svg>
);

export default ArrowIcon;
